import { RechtsgueltigHaengigOption } from '../../../core/gb-api';
import { Component, forwardRef, ViewChild } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { CapFormControlComponent } from '../../form-control/form-control.component';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-tagebuchstatus-selection',
  templateUrl: './tagebuchstatus-selection.component.html',
  styleUrls: ['./tagebuchstatus-selection.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RechtsgueltigHaengigComponent),
      multi: true
    }
  ],
  imports: [CapFormControlComponent, FormsModule, MetaDisablerDirective, MetaValidatorDirective, TranslatePipe]
})
export class RechtsgueltigHaengigComponent {
  @ViewChild(NgForm, { static: false })
  form: NgForm;

  model: RechtsgueltigHaengigOption;
  propagateChange: (id: string) => void;
  propagateTouch: (_) => void;

  constructor() {}

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }
}
